import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const token = localStorage.getItem('token');


    // Kontrolli kas kasutaja on sisse logitud JA on token JA on roll
    if (!isLoggedIn || !token) {
        return <Navigate to="/" replace />;
    }

    // Kui kõik on korras, näita kaitstud sisu
    return <Outlet />;
};

export default ProtectedRoute;